import React from "react";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer
} from "recharts";
import CustomLabel from "./custom-label";
import TooltipContent from "./tooltip-content";
import Teams from "../../../../../api/Teams";

function HorizontalBar({
  prefix = "",
  suffix = "",
  precision = 2,
  data = [],
  barSize = 18
}) {
  const colors = Teams.competitiveColors();

  return (
    <ResponsiveContainer width="100%" height={200}>
      <BarChart data={data} barSize={barSize}>
        <XAxis dataKey="name" tickLine={false} tick={false} />
        <YAxis domain={[dataMin => 0, dataMax => dataMax * 1.5]} hide={true} />
        <Tooltip content={<TooltipContent prefix={prefix} suffix={suffix} />} />
        <Bar
          dataKey="value"
          minPointSize={5}
          label={
            <CustomLabel
              prefix={prefix}
              suffix={suffix}
              precision={precision}
            />
          }
        >
          {colors.map((color, i) => (
            <Cell key={i} fill={color} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}

export default HorizontalBar;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/competitive/charts/horizontal-bar.js